import React from 'react'
import styles from './Confidence.module.scss'
import { motion } from "framer-motion"


const titleAnimation = {
    hidden: {
        y: 200,
        opacity: 0,
    },

    visible: {
        y: 0,
        opacity: 1,
        transition: { duration: .5 }
    }
}

const cardAnimation = {
    hidden: {
        y: 100,
        opacity: 0,
    },
    visible: {
        y: 0,
        opacity: 1,
        transition: { duration: .7}
    } 
}



const Confidence = () => {

    return (
        <motion.section 
            className={styles.main}
            id='Advantages'
            initial='hidden'
            whileInView='visible'
            viewport={{amount: 0.1, once: true}}
            >
            <div className={styles.box}>
                <motion.h2 className={styles.title} variants={titleAnimation}><span>6 ключевых преимуществ </span> по которым заказчики выбирают  нас</motion.h2>
                <motion.ul className={styles.list}>
                    <motion.li 
                        className={styles.item}
                        variants={cardAnimation}
                        initial='hidden'
                        whileInView='visible'
                        viewport={{amount: 0.05, once: true}}
                        >
                        <div className={styles.item_box} >
                            <p className={styles.item_number}>01</p>
                            <p className={styles.item_title}>Собственное производство</p>
                        </div>
                        <p className={styles.item_text}><span>Нет ограничений - навес по любым пожеланиям.</span> От типовых до индивидуальных проектов.</p>
                    </motion.li>
                    <motion.li 
                        className={styles.item}
                        variants={cardAnimation}
                        initial='hidden'
                        whileInView='visible'
                        viewport={{amount: 0.05, once: true}}
                        >
                        <div className={styles.item_box} >
                            <p className={styles.item_number}>02</p>
                            <p className={styles.item_title}>Демократичные цены</p>
                        </div>
                        <p className={styles.item_text}><span>Сэкономим до 20% на материалах и комплектующих.</span> За счет собственного производства.</p>
                    </motion.li>
                    <motion.li 
                        className={styles.item}
                        variants={cardAnimation}
                        initial='hidden'
                        whileInView='visible'
                        viewport={{amount: 0.05, once: true}}
                        >
                        <div className={styles.item_box} >
                            <p className={styles.item_number}>03</p>
                            <p className={styles.item_title}>Выезд замерщика</p>
                        </div>
                        <p className={styles.item_text}><span>Замерщик выедет бесплатно удобное для Вас время.</span> Обследует грунт и проконсультирует по выбору и монтажу навеса.</p>
                    </motion.li>
                    <motion.li 
                        className={styles.item}
                        variants={cardAnimation}
                        initial='hidden'
                        whileInView='visible'
                        viewport={{amount: 0.05, once: true}}
                        >
                        <div className={styles.item_box} >
                            <p className={styles.item_number}>04</p>
                            <p className={styles.item_title}>Высокий профессионализм</p>
                        </div>
                        <p className={styles.item_text}>Подберем лучший вариант монтажа вашего навеса. <span>Произведем монтаж за 1-2 дня на любых типах грунта.</span></p>
                    </motion.li>
                    <motion.li 
                        className={styles.item}
                        variants={cardAnimation}
                        initial='hidden'
                        whileInView='visible'
                        viewport={{amount: 0.05, once: true}}
                        >
                        <div className={styles.item_box} >
                            <p className={styles.item_number}>05</p>
                            <p className={styles.item_title}>Комплексный подход</p>
                        </div>
                        <p className={styles.item_text}><span>Производим полный цикл работ.</span> Подбор, замеры, проектирование, доставка, монтаж и последующее обслуживание.</p>
                    </motion.li>
                    <motion.li 
                        className={styles.item}
                        variants={cardAnimation}
                        initial='hidden'
                        whileInView='visible'
                        viewport={{amount: 0.05, once: true}}
                        >
                        <div className={styles.item_box} >
                            <p className={styles.item_number}>06</p>
                            <p className={styles.item_title}>Гарантия качества</p>
                        </div>
                        <p className={styles.item_text}>Мы осуществляем контроль качества на каждом из этапов.<span> Поэтому гарантируем качество наших навесов и выполненых работ.</span></p>
                    </motion.li>
                </motion.ul>
            </div>
        </motion.section>
    )
}

export default Confidence